import { ActionIcon, useMantineColorScheme } from '@mantine/core';
import { Moon, Sun } from 'lucide-react';

export function ThemeToggle() {
  const { colorScheme, toggleColorScheme } = useMantineColorScheme();

  return (
    <ActionIcon onClick={toggleColorScheme} variant="default">
      {colorScheme === 'dark' ? <Sun size={16} /> : <Moon size={16} />}
    </ActionIcon>
  );
}
